export default "__VITE_ASSET__8q8gXnf6__"